export default __webpack_public_path__ + "static/media/GT-Walsheim-Medium.b2d48248.woff";